// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"93":"9bd74149","536":"a6f21677","839":"9d6fb773","887":"3aa48b67"}[chunkId] + ".chunk.css";
};